// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"226d7787","455":"5fe0e445","977":"5ef96bd9"}[chunkId] + ".chunk.js";
};